import React, {Component} from 'react'
import { Tabs, Tab, Container, Row, Col} from 'react-bootstrap'


import PeopleList from '../components/PeopleList'

class TripDetails extends Component {
   render() {
      return (
         <div>
           <PeopleList></PeopleList>
       </div>
      )
   }
}

export default TripDetails;